import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editModal,
  openModal,
  resetFormState,
  setSelectValidError,
} from "../../../../slices/common/reducer";
import { UsersModalLayoutJSON } from "./Json/UsersLayoutJson";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { createUser, updateUser } from "./UserService";
import { setUserEditID } from "../../../../slices/team/users/usersSlice";
import { getOrgId } from "../../../../Utils/CommonUtils";

const NewUserModal = ({ rolesData }) => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const edit = useSelector((state) => state.common.editShow);
  const formState = useSelector((state) => state.common.formRendererState);
  const UserUpdateId = useSelector((state) => state.users.userEdit.id);
  const usersFieldJson = useSelector((state) => state.users.usersFieldJson);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    dispatch(setUserEditID(null));
    dispatch(setSelectValidError(false));
  };

  const addNewClickHandler = (e) => {
    console.log("Button clicked")
    e.preventDefault();
    if (formState.role_id && formState.status) {
      dispatch(setSelectValidError(false));
      createUser(formState, "AGSU", organizationId);
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    if (formState.role_id && formState.status) {
      dispatch(setSelectValidError(false));
      updateUser(formState, UserUpdateId, "AGSU");
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={() => handleClose()}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form
        className="tablelist-form"
        onSubmit={edit === false ? addNewClickHandler : updateClickHandler}
      >
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {edit ? "Update User Details" : "Add New User"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {UsersModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, usersFieldJson, formState, rolesData)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                {/* <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => handleClose(false)}
                >
                  Close
                </button> */}
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {edit ? "Update" : "Save"}
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default NewUserModal;